import React from 'react'
import { useSelector } from 'react-redux'
import { result } from 'libraries/lodash'
import { refreshPrecedents } from 'services/PrecedentsService'
import HeadingContainer from 'redux/containers/pages/precedentscontent/HeadingContainer'
import Forbidden from 'components/shared/Forbidden'
import Error from 'components/shared/Error'
import selectIsLimitedAccess from 'redux/selectors/selectIsLimitedAccess'
import selectAolName from 'redux/selectors/selectAolName'

const PrecedentsReviewSections = ({ title, sectionId, category, response, filteredParents }) => {
  const childSections = result(response, 'childSections', [])
    .filter(id => result(filteredParents, id, []).length > 0)
    .map(id => response.nodes[id])

  if (childSections.length) {
    return <ChildSections {...{ childSections, title, sectionId, category, response, filteredParents }} />
  }

  const isLimitedAccess = useSelector(selectIsLimitedAccess)

  return isLimitedAccess ? <Forbidden /> : <Error title='No content' />
}

const ChildSections = ({ childSections, title, sectionId, category, response, filteredParents }) => {
  const aol = useSelector(selectAolName)
  const nodes = result(response, 'nodes')
  const handleRefreshPrecedents = () => refreshPrecedents(aol)

  return (
    <ul className='menu pl0'>
      {childSections.map(({ id }) => (
        <HeadingContainer
          key={id}
          {...{ id, title, sectionId, nodes }}
          view={category}
          files={response.files}
          parents={filteredParents}
          refreshPrecedents={handleRefreshPrecedents}
        />
      ))}
    </ul>
  )
}

export default PrecedentsReviewSections
